import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';

interface LoadingContainerProps {
  loaderTitle: string;
  description?: string;
}

const LoadingContainer = ({ loaderTitle, description }: LoadingContainerProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: '40px'
      }}
    >
      <Typography
        component="h4"
        align="center"
        sx={{
          fontFamily: theme?.MojitoClaim?.font?.primary,
          fontWeight: 500,
          fontSize: '24px',
          padding: '24px 0 16px 0'
        }}
      >
        {loaderTitle || 'Processing...'}
      </Typography>
      <Typography
        sx={{
          fontFamily: theme?.MojitoClaim?.font?.secondary
        }}
        align="center"
      >
        {description || 'Please do not leave or reload this window.'}
      </Typography>
    </Box>
  );
};

export default LoadingContainer;
